export default "__VITE_ASSET__BRRVIrk$__"